import { createSelector } from 'reselect';
import { IQuestion, IQuestionDB, IQuestionPart } from '../../types';
import { notesEditor } from '../notes/resource';
import { questionsEditor } from './resource';
import { selector } from './reducer';

const questionItemSelector = createSelector(
  notesEditor.selectors.item,
  questionsEditor.selectors.item,
  (item, itemQuestion) => {
      var question: IQuestion = item;
      if (itemQuestion.noteId===item.id) {
        const quest = itemQuestion as IQuestionPart; 
        if (quest) {
          question.status = quest.status;
          question.antwoordConcern = quest.antwoordConcern;       
          question.practicionerId = quest.practicionerId;             
        }
        
      }
      return question;
  },
);

export default {
  currentitem: (state: any) => state.questionReducer.questionselected,
  questionItemSelector: questionItemSelector,
  open: (state: any) => state.questionReducer&&!!state.questionReducer.dropdownopen,
  opendropdownPracticioner: (state: any) => state.questionReducer&&!!state.questionReducer.dropdownopenPracticioner,
  inspect: (state: any) => state ? state.questionReducer.inspect : {}  as (IQuestionDB),  
  linking: (state: any) => state ? state.questionReducer.linkvisible: false,
  showlinks: (state: any) => state ? state.questionReducer.showlinks: false,
  showitem: (state: any) => state ? state.questionReducer.showitem: false,  
  ismaximized: (state: any) => state ? state.questionReducer.maximized: false,  
  linkitem: createSelector(selector, (state) => state.linkitem),  
  searchTermLinkingSelector: createSelector(selector, (state) => state.searchTermLinking),
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/selectors.tsx